import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import FullScreenLoader from "./FullScreenLoader";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { canViewModule } from "../utils/moduleAccess";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [usuario] = useLocalStorage("usuario", null);
  const [permiso] = useLocalStorage("permiso", null);
  const { permisoCheck } = rest;
  if (!usuario || usuario === null || !permiso) return <FullScreenLoader />;
  const hasAccess = canViewModule(permiso, permisoCheck);

  if (hasAccess) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  } else {
    return <Redirect to="/inicio" />;
  }
};

PrivateRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.func,
};

export default PrivateRoute;
